import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SweetAlert from "react-bootstrap-sweetalert";
import Box from "@mui/material/Box";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import axios from "axios";
import Select from "react-select";
import Pagination from "../../Pagination/Pagination";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import { useAppContext } from "../../Lib/ContextLib";
import html2pdf from "html2pdf.js";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { ViewList } from "@mui/icons-material";
import EmptyState from "../../Components/EmptyState";


const filterSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: "10px",
    border: state.isFocused ? "1.5px solid #ffc107" : "1.5px solid #e2e8f0",
    boxShadow: state.isFocused ? "0 0 0 4px rgba(255, 193, 7, 0.15)" : "0 1px 2px rgba(0, 0, 0, 0.03)",
    padding: "2px 8px",
    fontSize: "0.95rem",
    backgroundColor: "#ffffff",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: state.isFocused ? "#ffc107" : "#cbd5e1",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#ffc107"
      : state.isFocused
      ? "rgba(255, 193, 7, 0.1)"
      : "#fff",
    color: state.isSelected ? "#000" : "#1e293b",
    padding: "10px 15px",
    cursor: "pointer",
    "&:active": { backgroundColor: "#ffc107" },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "12px",
    boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)",
    overflow: "hidden",
    border: "1px solid #e2e8f0",
    zIndex: 9999,
  }),
  indicatorSeparator: () => ({ display: "none" }),
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
};

export default function Payout() {
  

  const { state } = useLocation();
  let { data } = state;
  console.log("useLocation :::", data);

  const { accessObject, showPage, setShowPage } = useAppContext();
  const { socket } = useAppContext();
  // const [searchPhoneNo, setSearchPhoneNo] = React.useState();
  // const [dataRows, setdataRows] = React.useState([]);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [loader, setLoader] = React.useState(false);
  const [changeStatus, setChangeStatus] = React.useState(3);
  const [filteredData, setFilteredData] = React.useState([]);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });
  const [alert, setAlert] = React.useState(null);
  const [rowValue, setRowValue] = React.useState();
  const [showBankDetails, setShowBankDetails] = React.useState([]);
  const [buttonLoader, setButtonLoader] = React.useState(false);
  const [filterEmail, setFilterEmail] = React.useState("");
  const [pageNumber, setPageNumber] = React.useState(1);
  const [recordLength, setRecordLength] = React.useState(10);
  const [totalLength, setTotalLength] = React.useState(0);
  const [buttonLoaderDecline, setButtonLoaderDecline] = React.useState(false);

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  React.useEffect(() => {
    getBranch();
  }, [filterEmail, pageNumber, recordLength, changeStatus]);

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const getBranch = () => {
    setLoader(true);
    axios
      .post(`${API_URL}/api/admin/history/get-history-payout-data`, {
        pageNumber: pageNumber,
        recordLength: recordLength,
        status: parseInt(changeStatus),
        search: filterEmail,
      })
      .then((response) => {
        setLoader(false);
        console.log("payout=============>", response.data.data);
        if (response?.data?.data?.totalLength > 0) {
          setFilteredData(response.data.data.getHistoryData);
          setTotalLength(response.data.data.totalLength);
        } else {
          setFilteredData([]);
          setTotalLength(0);
        }
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };

  const handleApprove = (item) => {
    console.log("item...", item);
    setButtonLoader(true);
    const data = {
      historyId: item.historyId,
    };
    console.log("item::: ", data);
    axios(`${API_URL}/api/admin/history/withdraw-money-approve`, {
      method: "POST",
      credentials: "include",
      data: data,
    })
      .then((response) => {
        console.log("response::: ", response);
        getBranch();
        setChangeStatus(3);
        socket.emit("PlayerPayment");
        setButtonLoader(false);
        toast.success(response.data.message);
        setShowPage(false);
      })
      .catch((error) => {
        setChangeStatus(3);
        setButtonLoader(false);
        toast.success(error.message);
        console.log("getBranch error :::", error);
        setShowPage(false);
      });
  };

  const handleDecline = (item) => {
    const data = {
      historyId: item.historyId,
    };
    setButtonLoaderDecline(true);
    console.log("item::: ", data);
    axios(`${API_URL}/api/admin/history/withdraw-money-decline`, {
      method: "POST",
      credentials: "include",
      data: data,
    })
      .then((response) => {
        console.log("response::: ", response);
        getBranch();
        setChangeStatus(3);
        socket.emit("PlayerPayment");
        setShowPage(false);
        // alert(response.data.message);
        toast.success(response?.data?.message);
        setButtonLoaderDecline(false);
        setAlert(null);
      })
      .catch((error) => {
        // alert(error.message);
        setChangeStatus(3);
        toast.success(error?.message);
        console.log("getBranch error :::", error);
        setAlert(null);
      });
  };

  const clickEditButton = (item) => {
    console.log("item edit value :::", item);
    setShowBankDetails(item);
    setShowPage(true);
    setRowValue(item);
  };

  const warningWithConfirmMessage = (item) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Decline"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          handleDecline(item);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert"
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to decline this payout request. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  return (
    <div>
      {alert}
      {showPage ? (() => {
        const withdrawTypeLabel = rowValue?.withdrawType === 1 ? "UPI" : rowValue?.withdrawType === 2 ? "Bank Transfer" : "Paypal / Other";
        const withdrawTypeIcon = rowValue?.withdrawType === 1 ? "fas fa-mobile-alt" : rowValue?.withdrawType === 2 ? "fas fa-university" : "fas fa-paypal";

        const InfoCard = ({ label, value }) => (
          <div style={{ background: "#f8f9fa", borderRadius: "10px", padding: "14px 18px", marginBottom: "12px", borderLeft: "4px solid #f5a623" }}>
            <div style={{ fontSize: "11px", fontWeight: "600", color: "#999", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "4px" }}>{label}</div>
            <div style={{ fontSize: "15px", fontWeight: "600", color: "#2d3748" }}>{value || "-"}</div>
          </div>
        );

        return (
          <div className="content p-3">
            <div className="card" style={{ borderRadius: "12px", border: "none", boxShadow: "0 2px 20px rgba(0,0,0,0.08)" }}>
              {/* Header */}
              <div className="card-header bg-white" style={{ borderRadius: "12px 12px 0 0", borderBottom: "1px solid #f0f0f0", padding: "18px 24px" }}>
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div style={{ width: "40px", height: "40px", background: "#f5a623", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "14px" }}>
                      <i className="fas fa-money-bill-wave" style={{ color: "#fff", fontSize: "18px" }}></i>
                    </div>
                    <div>
                      <h5 style={{ margin: 0, fontWeight: "700", color: "#2d3748" }}>
                        {rowValue?.isView ? "Withdrawal Details" : "Process Withdrawal"}
                      </h5>
                      <div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "2px" }}>
                        <small style={{ color: "#999" }}>ID: {rowValue?.historyId || rowValue?._id}</small>
                        <button
                          type="button"
                          title="Copy ID"
                          onClick={() => {
                            const id = rowValue?.historyId || rowValue?._id;
                            if (id) { navigator.clipboard.writeText(id); toast.success("ID copied!"); }
                          }}
                          style={{ background: "none", border: "none", padding: "0 2px", cursor: "pointer", color: "#bbb", fontSize: "12px", lineHeight: 1 }}
                        >
                          <i className="fas fa-copy"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <button className="btn btn-outline-secondary btn-sm" style={{ borderRadius: "8px", fontWeight: "600" }} onClick={() => setShowPage(false)}>
                    ← Back to List
                  </button>
                </div>
              </div>

              <div className="card-body" style={{ padding: "24px" }}>
                {/* Amount Banner */}
                <div style={{ background: "linear-gradient(135deg, #1a202c, #2d3748)", borderRadius: "14px", padding: "24px 28px", marginBottom: "24px" }}>
                  <div style={{ color: "rgba(255,255,255,0.5)", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "1.5px", marginBottom: "8px" }}>Withdrawal Amount</div>
                  <div style={{ color: "#ffffff", fontSize: "38px", fontWeight: "800", marginBottom: "20px", lineHeight: 1 }}>
                    ₹ {Math.round((rowValue?.amount || 0) * 100) / 100}
                  </div>
                  <div style={{ display: "flex", gap: "32px", alignItems: "flex-start" }}>
                    <div>
                      <div style={{ color: "rgba(255,255,255,0.45)", fontSize: "10px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "1px", marginBottom: "6px" }}>Method</div>
                      <span style={{ color: "#fff", fontSize: "14px", fontWeight: "700" }}>{withdrawTypeLabel}</span>
                    </div>
                    <div style={{ width: "1px", background: "rgba(255,255,255,0.1)", alignSelf: "stretch" }}></div>
                    <div>
                      <div style={{ color: "rgba(255,255,255,0.45)", fontSize: "10px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "1px", marginBottom: "6px" }}>Status</div>
                      <span style={{ color: "#fff", fontSize: "14px", fontWeight: "700" }}>
                        <span style={{ display: "inline-block", width: "8px", height: "8px", borderRadius: "50%", background: rowValue?.status === 1 ? "#28a745" : rowValue?.status === 2 ? "#dc3545" : "#f5a623", marginRight: "6px", verticalAlign: "middle" }}></span>
                        {rowValue?.status === 0 ? "Pending" : rowValue?.status === 1 ? "Approved" : rowValue?.status === 2 ? "Declined" : "-"}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Payment Details */}
                <div className="row">
                  {/* UPI */}
                  {rowValue?.withdrawType === 1 && (
                    <div className="col-md-6">
                      <div style={{ marginBottom: "12px" }}>
                        <div style={{ fontSize: "12px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "10px", paddingBottom: "6px", borderBottom: "2px solid #f1f5f9" }}>
                          <i className="fas fa-mobile-alt mr-2" style={{ color: "#f5a623" }}></i>UPI Details
                        </div>
                        <InfoCard label="UPI ID" value={rowValue?.upiId} />
                      </div>
                    </div>
                  )}

                  {/* Bank / Paypal */}
                  {(rowValue?.withdrawType === 2 || rowValue?.withdrawType === 0) && (
                    <>
                      <div className="col-md-6">
                        <div style={{ fontSize: "12px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "10px", paddingBottom: "6px", borderBottom: "2px solid #f1f5f9" }}>
                          <i className="fas fa-user mr-2" style={{ color: "#f5a623" }}></i>Payment Info
                        </div>
                        <InfoCard label="Payment Country" value={rowValue?.paymentCountry} />
                        <InfoCard label="Payment Contact" value={rowValue?.paymentContact} />
                        <InfoCard label="Payment User Name" value={rowValue?.paymentUserName} />
                        <InfoCard label="Paypal Email" value={rowValue?.paypalEmail} />
                        <InfoCard label="Paypal User Name" value={rowValue?.paypalUserName} />
                      </div>
                      <div className="col-md-6">
                        <div style={{ fontSize: "12px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "10px", paddingBottom: "6px", borderBottom: "2px solid #f1f5f9" }}>
                          <i className="fas fa-university mr-2" style={{ color: "#f5a623" }}></i>Bank Details
                        </div>
                        <InfoCard label="Bank Unique No" value={rowValue?.bankUniqueNo} />
                        <InfoCard label="Bank Account Type" value={rowValue?.bankAccountType} />
                        <InfoCard label="Bank Account No" value={rowValue?.bankAccountNo} />
                      </div>
                    </>
                  )}
                </div>

                {/* Action Buttons */}
                {!rowValue?.isView && (
                  <div style={{ display: "flex", gap: "12px", marginTop: "8px", paddingTop: "20px", borderTop: "1px solid #f0f0f0" }}>
                    <button
                      className="btn btn-primary"
                      style={{ minWidth: "130px", borderRadius: "8px", fontWeight: "700", padding: "10px 20px" }}
                      disabled={buttonLoader}
                      onClick={() => handleApprove(rowValue)}
                    >
                      {buttonLoader ? (
                        <><span className="spinner-border spinner-border-sm mr-2"></span>Processing...</>
                      ) : (
                        <><i className="fas fa-check mr-2"></i>Approve</>
                      )}
                    </button>
                    <button
                      className="btn btn-danger"
                      style={{ minWidth: "130px", borderRadius: "8px", fontWeight: "700", padding: "10px 20px" }}
                      disabled={buttonLoaderDecline}
                      onClick={() => handleDecline(rowValue)}
                    >
                      {buttonLoaderDecline ? (
                        <><span className="spinner-border spinner-border-sm mr-2"></span>Processing...</>
                      ) : (
                        <><i className="fas fa-times mr-2"></i>Decline</>
                      )}
                    </button>
                    <button
                      className="btn btn-outline-secondary"
                      style={{ minWidth: "100px", borderRadius: "8px", fontWeight: "600", padding: "10px 20px" }}
                      onClick={() => setShowPage(false)}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })() : (
        <div className="content p-3">
          <div class="card ">
          <div className="card-header bg-white border-bottom-0 pb-0 pt-4 px-4">
              <div className="row align-items-end">
                <div className="col-md-3">
                  <label className="small text-muted font-weight-bold mb-1">Status</label>
                  <Select
                    styles={filterSelectStyles}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    options={[
                      { value: 3, label: "All" },
                      { value: 0, label: "Pending" },
                      { value: 1, label: "Approve" },
                      { value: 2, label: "Decline" },
                    ]}
                    value={{
                      value: changeStatus,
                      label: changeStatus === 3 ? "All" : changeStatus === 0 ? "Pending" : changeStatus === 1 ? "Approve" : "Decline",
                    }}
                    onChange={(option) => {
                      setPageNumber(1);
                      setRecordLength(10);
                      setChangeStatus(option.value);
                    }}
                  />
                </div>
                <div className="col-md-5">
                  <label className="small text-muted font-weight-bold mb-1">Search Email</label>
                  <div className="d-flex align-items-center">
                    <div className="position-relative flex-grow-1">
                      <i className="fas fa-search text-muted position-absolute" style={{ left: '16px', top: '50%', transform: 'translateY(-50%)', zIndex: 10, fontSize: '0.9rem' }}></i>
                      <input
                        className="form-control premium-search-input"
                        type="text"
                        value={filterEmail}
                        placeholder="Search Email..."
                        onChange={(e) => {
                          setPageNumber(1);
                          setRecordLength(10);
                          setFilterEmail(e.target.value);
                        }}
                      />
                    </div>
                    <button
                      onClick={() => getBranch()}
                      className="btn ml-2"
                      style={{
                        height: "45px",
                        width: "45px",
                        borderRadius: "12px",
                        border: "1.5px solid #e2e8f0",
                        background: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#64748b",
                        transition: "all 0.2s ease",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
                      }}
                      title="Refresh"
                    >
                      <i className="fas fa-sync-alt"></i>
                    </button>
                  </div>
                </div>
                <div className="col-md-4 text-right">
                  {accessObject?.payoutDownload == true && (
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        const input = document.getElementById("download-PDF");
                        const opt = { filename: "Payout-List.pdf" };
                        html2pdf().set(opt).from(input).save().from().toPdf();
                      }}
                    >
                      Download PDF
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div
              class="card-body"
              id="download-PDF"
              style={{ overflow: "scroll" }}
            >
              <table
                class="table table-bordered table-striped"
                id="table-to-xls"
              >
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}>Id</th>
                    <th style={{ textAlign: "center" }}>Date</th>
                    <th style={{ textAlign: "center" }}>Player Id</th>
                    <th style={{ textAlign: "center" }}>Email</th>
                    <th style={{ textAlign: "center" }}>Amount</th>
                    <th style={{ textAlign: "center" }}>Status</th>
                    <th style={{ textAlign: "center" }}>Action</th>
                  </tr>
                </thead>

                {accessObject?.getPayoutList == true ? (
                  <>
                    <tbody>
                      {!loader ? (
                        <>
                          {filteredData.length > 0 ? (
                            <>
                              {filteredData?.map((item, index) => (
                                <>
                                  <tr
                                    key={index}
                                    style={{ textAlign: "center" }}
                                  >
                                    <td style={{ textAlign: "center" }}>
                                      {pageNumber === 1
                                        ? index + 1
                                        : index +
                                          1 +
                                          pageNumber * recordLength -
                                          recordLength}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {moment(item.createdAt).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.playerId ? item.playerId : "-"}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.email ? item.email : "-"}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {Math.round(item.amount * 100) / 100}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.status === 0
                                        ? "Pending"
                                        : item.status === 1
                                        ? "Success"
                                        : item.status === 2
                                        ? "Failed"
                                        : "-"}
                                    </td>
                                    {item?.status === 0 ? (
                                      <td style={{ textAlign: "center" }}>
                                        <EditIcon
                                          className="mr-3 courser"
                                          onClick={() => clickEditButton(item)}
                                        />
                                        <ClearIcon
                                          className="courser text-danger"
                                          onClick={() =>
                                            warningWithConfirmMessage(item)
                                          }
                                        />
                                      </td>
                                    ) : (
                                      <td style={{ textAlign: "center" }}>
                                        <div className="d-flex justify-content-center">
                                          <VisibilityIcon
                                            className="courser"
                                            style={{ color: '#000', cursor: 'pointer', fontSize: '20px' }}
                                            onClick={() => clickEditButton({ ...item, isView: true })}
                                          />
                                        </div>
                                      </td>
                                    )}
                                  </tr>
                                </>
                              ))}
                            </>
                          ) : (
                            <EmptyState colSpan={7} />
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </tbody>
                  </>
                ) : (
                  <>
                    <tr style={{ backgroundColor: "rgba(0,0,0,.05)" }}>
                      <td colSpan={9}>
                        <h5 className="text-center">Access Denied</h5>
                      </td>
                    </tr>
                  </>
                )}
              </table>
              {accessObject?.getPayoutList == true && (
                <div className="mt-4">{loader && <Loader />}</div>
              )}
            </div>
            {accessObject?.getPayoutList == true &&
              filteredData.length != 0 && (
                <Pagination
                  updateShowPerpagevalue={updateShowPerpagevalue}
                  showPrePage={showPrePage}
                  onPaginationChange={onPaginationChange}
                  total={filteredData.length}
                  paginationTypeApi={true}
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                  recordLength={recordLength}
                  setRecordLength={setRecordLength}
                  totalLength={totalLength}
                />
              )}
          </div>
        </div>
      )}
    </div>
  );
}
